<template>
  <div v-if="addressToShow !== undefined">
    <p class="font-weight-bolder mb-0">
      <span class="font-weight-bolder">
        {{ addressToShow.name }}
      </span>
      -
      <span class="font-weight-bolder">
        {{ addressToShow.phone_number }}
      </span>
    </p>
    <p class="mb-0">
      {{ addressToShow.address }}
    </p>
    <p class="font-size-12">
      {{ addressToShow.address_detail }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'PreviewAddress',
  props: {
    type: {
      type: String,
      required: true
    },
    listAddress: {
      type: Array,
      required: true
    }
  },
  computed: {
    addressToShow() {
      const filtered = this.listAddress.filter(item => item.type === this.type)
      if (this.type === 'pickup') {
        return filtered[0]
      } else {
        return filtered.pop()
      }
    }
  }
}
</script>